import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMAGES, WA_PIERCING } from "../../lib/constants";
import { Lightbox } from "./Lightbox";

export const Piercing = () => {
  const [active, setActive] = useState(null);
  const items = IMAGES.piercing;
  return (
  <section id="piercing" className="bg-white text-[#0A0A0A] py-24 lg:py-32 px-6" data-testid="piercing-section">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-4 lg:sticky lg:top-32"
        >
          <p className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-3">PIERCING & JOIAS</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl leading-none">
            Brilho com <span className="italic text-[#E60000]">precisão</span>
          </h2>
          <p className="mt-6 text-base font-light leading-relaxed text-[#0A0A0A]/70">
            Furos com técnica, anestesia tópica quando indicada e um catálogo de joias em aço cirúrgico e titânio — tudo com certificado e acompanhamento de cicatrização.
          </p>
          <a
            href={WA_PIERCING}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="piercing-cta-button"
            className="btn-sharp mt-8 inline-flex items-center gap-2 bg-[#0A0A0A] hover:bg-[#E60000] text-white text-xs tracking-[0.15em] font-extrabold px-8 py-4 transition-colors duration-300"
          >
            VER CATÁLOGO NO WHATSAPP <ArrowUpRight size={14} />
          </a>
        </motion.div>

        <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {items.map((item, i) => (
            <motion.button
              key={item.title}
              onClick={() => setActive(i)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className={`img-frame group relative border border-black/10 aspect-[3/4] text-left cursor-zoom-in ${i === 0 ? "sm:row-span-2 sm:aspect-auto" : ""}`}
              data-testid={`piercing-item-${i}`}
            >
              <img src={item.src} alt={item.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
              <div className="absolute inset-0 bg-[#0A0A0A]/0 group-hover:bg-[#0A0A0A]/20 transition-colors duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-5 bg-gradient-to-t from-[#0A0A0A]/80 to-transparent">
                <p className="text-[10px] tracking-[0.3em] font-bold text-[#E60000]">{item.tag}</p>
                <h3 className="font-display italic font-bold text-white text-xl mt-1">{item.title}</h3>
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </div>
    <Lightbox items={items} index={active} onClose={() => setActive(null)} onNav={setActive} />
  </section>
  );
};
